import React from 'react';

import getDisplayName from '../../utils/get-display-name';
import DocumentTitle from './DocumentTitle';

export default function withDocumentTitle(title) {
  return WrappedComponent => {
    function WithDocumentTitle(props) {
      return (
        <DocumentTitle
          title={typeof title === 'function' ? title(props) : title}
        >
          <WrappedComponent {...props} />
        </DocumentTitle>
      );
    }

    WithDocumentTitle.displayName = `withDocumentTitle(${getDisplayName(
      WrappedComponent,
    )})`;

    return WithDocumentTitle;
  };
}
